/*
 * App-wide configuration constants.
 *
 * API_BASE_URL is the ONE place the backend host is written down.
 *
 * It is empty by default, which means every request is same-origin: the browser
 * asks whatever host served the page, and nginx there proxies /api/web/* to the
 * web-auth service (port 8002) and /api/* to the platform API (port 8001).
 *
 * That is deliberate. The same built bundle then works unchanged on
 * web.donquack.com and on donquack.com, and no request is ever cross-origin, so
 * there is no CORS allowlist to keep in step with our hostnames.
 *
 * Set VITE_API_BASE_URL to point at an absolute backend instead (the Vite dev
 * server does this via a proxy — see vite.config.js).
 */

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

/** Where web auth + payment endpoints live: {API_BASE_URL}/api/web/... */
export const WEB_API_PREFIX = '/api/web';

/** localStorage key holding the 30-day session JWT. */
export const TOKEN_STORAGE_KEY = 'dq_token';

/** Languages the product ships in. Used by the language switcher. */
export const LANGUAGES = [
  { code: 'en', short: 'EN', label: 'English' },
  { code: 'ru', short: 'RU', label: 'Русский' },
  { code: 'es', short: 'ES', label: 'Español' },
  { code: 'pt', short: 'PT', label: 'Português' },
];

/** External destinations referenced from the marketing site and the app. */
export const TELEGRAM_BOT_URL = 'https://t.me/DonQuack_bot';

/*
 * The privacy policy is now a route on this site, not the old WordPress page.
 * It is a relative path so it stays same-origin and works on any hostname;
 * /privacy-policy is 301'd to it in nginx for anyone following an old link.
 */
export const PRIVACY_POLICY_URL = '/privacy';
export const TERMS_URL = '/terms';
